import * as types from './../actionTypes';
import client from 'helpers/client';
import {
  FETCH_LIST_CODE_BASE,
  FETCH_LIST_CODE_BASE_DETAIL,
  FETCH_RELEASE_DETAIL,
  GET_TRANSACTION,
  FETCH_LIST_DAO,
  FETCH_LIST_DAO_SUCCESS,
  FETCH_LIST_DAO_FAIL,
} from './../actionTypes';
import cognito from 'helpers/cognito';
import paths from 'redux/paths';

export const getCodebaseDetail = (params) => (dispatch) => {
  dispatch({ type: types.FETCH_LIST_CODE_BASE_DETAIL });
  return client
    .api('/code-base/get-code-base-detail', 'get', { params })
    .then(({ data: response }) => {
      dispatch({ type: types.FETCH_LIST_CODE_BASE_DETAIL_SUCCESS });
      return response;
    })
    .catch((err) => {
      dispatch({ type: types.FETCH_LIST_CODE_BASE_DETAIL_FAILED, reason: err });
      return null;
    });
};

export const getReleaseDetail = (params) => (dispatch) => {
  dispatch({ type: types.FETCH_RELEASE_DETAIL });
  return client
    .api('/code-base/get-release-detail', 'get', { params })
    .then(({ data: response }) => {
      dispatch({ type: types.FETCH_RELEASE_DETAIL_SUCCESS });
      return response;
    })
    .catch((err) => {
      dispatch({ type: types.FETCH_RELEASE_DETAIL_FAILED, reason: err });
      return null;
    });
};
export const fetchCodeBase = (params) => {
  return (dispatch) => {
    dispatch({ type: types.FETCH_LIST_CODE_BASE });

    client
      .api(`/code-base/get-list`, 'get', {
        params: params,
      })
      .then((res) => {
        dispatch({
          type: types.FETCH_LIST_CODE_BASE_SUCCESS,
          data: res.data.data,
          reason: 'Fetch code base success',
        });
      })
      .catch((err) =>
        dispatch({
          type: types.FETCH_LIST_CODE_BASE_FAIL,
          reason: err,
        }),
      );
  };
};

// export const postTransaction = (params) => (dispatch) => {
//   dispatch({ type: types.POST_NFT_TRANSACTION });
//   return client
//     .api('/nft/create-transaction', 'post', { params })
//     .then(({ data: response }) => {
//       dispatch({ type: types.POST_NFT_TRANSACTION_SUCCESS });
//       return response;
//     })
//     .catch((err) => {
//       dispatch({ type: types.POST_NFT_TRANSACTION_FAILED, reason: err });
//       return null;
//     });
// };

export const postTransaction = (params) => async (dispatch) => {
  try {
    console.log('params', params);
    dispatch({ type: types.POST_NFT_TRANSACTION });

    const res = await client.sendRequest({
      path: paths.POST_NFT_TRANSACTION,
      params,
      method: 'post',
      headers: await cognito.getHeaderAuthorization(),
    });

    const { status, data } = res;
    if (status !== 'OK') {
      throw new Error(res.error);
    }

    dispatch({ type: types.POST_NFT_TRANSACTION_SUCCESS });
    return res;
  } catch (err) {
    dispatch({
      type: types.POST_NFT_TRANSACTION_FAILED,
      error: err.message,
    });
    return err;
  }
};

export const getLicense = (params) => async (dispatch) => {
  try {
    console.log('params', params);
    dispatch({ type: types.GET_LICENSE });

    const res = await client.sendRequest({
      path: paths.GET_LICENSE,
      params,
      method: 'get',
      headers: await cognito.getHeaderAuthorization(),
    });

    const { status, data } = res;
    if (status !== 'OK') {
      throw new Error(res.error);
    }

    dispatch({ type: types.GET_LICENSE_SUCCESS });
    return res;
  } catch (err) {
    dispatch({
      type: types.GET_LICENSE_FAILED,
      error: err.message,
    });
    return err;
  }
};

export const getTransactionOfUser = (params) => async (dispatch) => {
  try {
    console.log('params', params);
    dispatch({ type: types.GET_TRANSACTION });

    const res = await client.sendRequest({
      path: paths.GET_TRANSACTION,
      params,
      method: 'get',
      headers: await cognito.getHeaderAuthorization(),
    });

    const { status, data } = res;
    if (status !== 'OK') {
      throw new Error(res.error);
    }

    dispatch({ type: types.GET_TRANSACTION_SUCCESS });
    return res;
  } catch (err) {
    dispatch({
      type: types.GET_LICENSE_FAILED,
      error: err.message,
    });
    return err;
  }
};

export const getLicenseByUser = (params) => async (dispatch) => {
  try {
    console.log('params', params);
    dispatch({ type: types.GET_LICENSE_BY_USER });

    const res = await client.sendRequest({
      path: paths.GET_LICENSE_BY_USER,
      params,
      method: 'get',
      headers: await cognito.getHeaderAuthorization(),
    });

    const { status, data } = res;
    if (status !== 'OK') {
      throw new Error(res.error);
    }

    dispatch({ type: types.GET_LICENSE_BY_USER_SUCCESS });
    return res;
  } catch (err) {
    dispatch({
      type: types.GET_LICENSE_BY_USER_FAILED,
      error: err.message,
    });
    return err;
  }
};
export const getDAOList = (params) => (dispatch) => {
  dispatch({ type: types.FETCH_LIST_DAO });
  return client
    .api('/daos', 'get', { params })
    .then(({ data: response }) => {
      dispatch({ type: types.FETCH_LIST_DAO_SUCCESS, data: response });
      return response;
    })
    .catch((err) => {
      dispatch({ type: types.FETCH_LIST_DAO_FAIL, error: err.message });
      return null;
    });
};
export const sendEmailConfirmAfterClaimLicense = (codebaseId, txHash) => async (dispatch) => {
  dispatch({ type: types.SEND_EMAIL_CONFIRM_START });

  try {
    const response = await client.api(
      '/nft/send-email-confirm-after-claim-license',
      'post',
      {
        codebaseId,
        txHash,
      },
      {
        headers: await cognito.getHeaderAuthorization(),
        provider: 'CognitoUserPool',
        'Content-Type': 'application/json',
      },
    );

    dispatch({ type: types.SEND_EMAIL_CONFIRM_SUCCESS, data: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: types.SEND_EMAIL_CONFIRM_FAIL, error: error.message });
    return null;
  }
};